/**

  Simplify the usage of groups of Radio Buttons by allowing the specification
  of `selectedValue` and `onSelectedValueChange` on this element,
  rather than on each child radio button.

*/
import compact from 'lodash/compact';
import React, { Children, Fragment, cloneElement } from 'react';

// This allows us to handle null values as well since they are not supported natively
const NULL_PLACEHOLDER = 'NULL_PLACEHOLDER';

const RadioButtonFunctionalSet = ({ children, selectedValue, onSelectedValueChange })=>
  <Fragment>
    {
      Children.map(compact(children), child =>
        cloneElement(
          child,
          {
            value: child.props.value === null ? NULL_PLACEHOLDER : child.props.value,
            checked: selectedValue === child.props.value,
            onChange: (e)=> {
              if (e.target.checked) {
                const value = e.target.value;
                onSelectedValueChange(value === NULL_PLACEHOLDER ? null : value);
              }
            }
          }
        )
      )
    }
  </Fragment>;

export default RadioButtonFunctionalSet;
